//#region Imports

import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { getAvatarInitials } from '../../utils/avatar.utils';

//#endregion

@Component({
  selector: 'l-avatar',
  standalone: true,
  templateUrl: './avatar.component.html',
  imports: [NgClass],
})
export class AvatarComponent {

  //#region Public Properties

  @Input({ required: true })
  public name!: string;

  @Input()
  public sizeClass: string = 'h-8 w-8 text-xs';

  public imageFailed: boolean = false;

  //#endregion

  //#region Private Properties

  private currentImageUrl: string = '';

  //#endregion

  //#region Getters

  @Input()
  public set imageUrl(value: string | null | undefined) {
    const nextImageUrl = value?.trim() ?? '';

    if (nextImageUrl !== this.currentImageUrl) {
      this.imageFailed = false;
    }

    this.currentImageUrl = nextImageUrl;
  }

  public get imageUrl(): string {
    return this.currentImageUrl;
  }

  public get initials(): string {
    return getAvatarInitials(this.name);
  }

  public get showImage(): boolean {
    return !!this.imageUrl && !this.imageFailed;
  }

  //#endregion

  //#region Public Methods

  public onImageError(): void {
    this.imageFailed = true;
  }

  //#endregion

}
